var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.9 14.8-4-6.3c-.7-1.1-2.1-1.4-3.2-.7S11.3 9.9 12 11l3.2 5.1-3.2 5.1c-.7 1.1-.4 2.5.7 3.2.4.2.8.4 1.2.4.8 0 1.5-.4 1.9-1.1l4-6.3c.6-.9.6-1.9.1-2.6"
  })));
};
export default SvgChevronRight;